import template from './storyAccessDenied.template.html'

export default {
  restrict: 'E',
  replace: false,
  template,
  controllerAs: 'vm',
  controller: 'StoryAccessDeniedController',
}
